/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { MediaContext, MediaLinkContext } from "../App";
import { useContext } from "react";

// console.log("---------");
// console.log(link);
// console.log(value);

export const useExportMedia = () => {
  const values = useContext(MediaContext);
  const { link } = useContext(MediaLinkContext);
  console.log("---------");
  console.log(link);
  console.log(values);

  const mediaList = [{ ...values[0], src: link }];

  const searchList = [...values];

  function getInitialMediaId() {
    const url = new URL(window.location);
    const params = url.searchParams;
    return params.get("mediaId");
  }

  const getInitialMediaItem = () => {
    const mediaId = getInitialMediaId();
    const mediaItem = mediaList.find(
      (mediaItem) => `${mediaItem.id}` === mediaId
    );
    return mediaItem ? mediaItem : mediaList[0];
  };

  return { mediaList, searchList, getInitialMediaItem };
};
